import React, { useEffect } from 'react';

import { BrowserRouter, Redirect, Route, Switch, useLocation } from 'react-router-dom';

import Home from './views/Home';
import Plans from './views/Plans';
import Capital from './views/Capital';
import Practice from './views/Practice';
import Funds from './views/Funds';
import Founders from './views/Founders';
import Partners from './views/Partners';

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const App = () => {
  useEffect(() => {
    const navbar = document.querySelector('.Topbar');
    if (!navbar) {
      return;
    }
    navbar.style.animation = 'none'; // Reset animation
    setTimeout(() => {
      navbar.style.animation = 'slideInFromTop 0.5s ease-out forwards';
    }, 50); // Small delay to ensure reset
  }, []); // Run only once on mount

  return (
    <div className="app">
      <BrowserRouter>
        <ScrollToTop />
        <Switch>
          <Route path="/plans" component={Plans} />
          <Route path="/home" component={Home} />
          <Route path="/capital" component={Capital} />
          <Route path="/practice" component={Practice} />
          <Route path="/funds" component={Funds} />
          <Route path="/founders" component={Founders} />
          <Route path="/partners" component={Partners} />
          <Redirect from="/*" to="/Capital" />
        </Switch>
      </BrowserRouter>
    </div>
  );
};

export default App;
